import { githubStatusApiSlice } from "state/services/githubStatusApiSlice";

// Maps Statuspage's indicator scale to this app's existing "healthy"/"unhealthy"
// health-check convention, so the compact StatusIndicator (used for the internal
// User/Organization/Platform services) can display GitHub's status without a
// GitHub-specific variant. "none" is the only indicator value that means fully
// operational — minor/major/critical all represent some degree of active issue.
const mapIndicatorToStatus = (indicator) =>
  indicator === "none" ? "healthy" : "unhealthy";

export const githubStatusQueries = githubStatusApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET https://www.githubstatus.com/api/v2/summary.json — public, unauthenticated,
    // no rate limit; returns overall status, every component, and any unresolved
    // incidents/active scheduled maintenances in one call.
    getGitHubStatus: builder.query({
      query: () => ({ url: "/summary.json" }),
      transformResponse: (responseData) => ({
        // Normalized fields for reuse with the existing StatusIndicator/ServiceCard components.
        status: mapIndicatorToStatus(responseData.status?.indicator),
        indicator: responseData.status?.indicator ?? "none",
        description: responseData.status?.description ?? "Unknown",
        // Raw GitHub-specific data for a richer detail view.
        components: responseData.components ?? [],
        incidents: responseData.incidents ?? [],
        scheduledMaintenances: responseData.scheduled_maintenances ?? [],
      }),
    }),
  }),
});

export const { useGetGitHubStatusQuery } = githubStatusQueries;
